// EG-38 (passo 3 BI) — design system dos dashboards do admin. Fonte ÚNICA de
// cores, raios e paleta de gráfico (espelha o do form). Se o azul é "nota", é o
// mesmo azul em todo lugar.

export const COLORS = {
  ink: "#292B30",
  inkMuted: "#5C6066",
  surface: "#FFFFFF",
  line: "#EDF2F7",
  track: "#EDF2F7",

  brand: "#0073BB",
  maturity: "#598F3C",
  cutoff: "#64645e",

  good: "#2F855A",
  warn: "#C05621",
  danger: "#C53030",
};

export const CHART = {
  primary: COLORS.brand,
  reference: COLORS.cutoff,
  good: COLORS.good,
  warn: COLORS.warn,
  danger: COLORS.danger,
};

// Paleta categórica pra série (ano, empresa) em gráfico com 2+ séries — NUNCA
// usar COLORS.warn/danger aqui: são cor de STATUS (atenção/erro), não
// identidade de série, e reaproveitar gera falso alarme visual num ano
// qualquer. Validada com scripts/validate_palette.js do skill dataviz:
// separação CVD e contraste normal-vision passam nos 6 slots, ancorada no
// azul de marca (slot 1 = COLORS.brand).
export const CATEGORICAL = [COLORS.brand, "#eb6834", "#1baf7a", "#eda100", "#4a3aa7", "#e34948"];

export const RADIUS = { card: "12px" };
